<template>
  <div v-if="items.length > 0">
    <el-table :data="items" header-row-class-name="thead-light">
      <el-table-column label="Cuota" min-width="120px" prop="quote">
        <template #default="{ $index }">
          <span v-if="lastIndex === $index">Total</span>
          <span v-else> Cuota {{ $index + 1 }} </span>
        </template>
      </el-table-column>
      <el-table-column label="Mes" min-width="80px" prop="month">
        <template #default="{ row }">
          <span> {{ months[row.month] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Año" min-width="80px" prop="year">
        <template #default="{ row, $index }">
          <span v-if="lastIndex === $index">{{ (row.commissionARS / row.commissionUSD) | decimals }}</span>
          <span v-else>{{ row.year }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Comisión en Dólares" min-width="140px" prop="commissionUSD">
        <template #default="{ row }">
          <span>{{ row.commissionUSD | toCurrencyUSD }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Comisión en Pesos" min-width="140px" prop="commissionARS">
        <template #default="{ row }">
          <span>{{ row.commissionARS | toCurrencyARS }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Porcentaje" min-width="120px" prop="percentage">
        <template #default="{ row }">
          <span>
            {{ (row.commissionUSD / usdTotal) | percentage }}
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { Table, TableColumn } from 'element-ui';

import { months } from '@/util/constants/months';

export default {
  name: 'CommissionsTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },

    lastIndex: {
      type: Number,
      default: 0,
    },

    usdTotal: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      months,
    };
  },
};
</script>
